import React from 'react'
import {Form} from "@redriver/cinnamon";

const NonPropagatingEmail = (props) => {
    return (
        <Form.Email {...props} onKeyDown={(e) => e.stopPropagation()} />
    )
}
export default NonPropagatingEmail
